var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-layout",
        { staticClass: "pt-4 pb-1", attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { class: { "pb-0": _vm.isMobile }, attrs: { xs12: "", sm4: "" } },
            [
              _c(
                "v-autocomplete",
                {
                  attrs: {
                    dense: "",
                    label: "Provider Name/Credentials",
                    placeholder: "Enter Provider Name",
                    items: _vm.providersArray,
                    clearable: true,
                    "error-messages": _vm.providerSearchError,
                    "return-object": true,
                    "search-input": _vm.providerSearchInput,
                    "item-text": "username",
                    loading: _vm.providerSearchLoading,
                    "no-filter": true
                  },
                  on: {
                    "update:searchInput": function($event) {
                      _vm.providerSearchInput = $event
                    },
                    "update:search-input": function($event) {
                      _vm.providerSearchInput = $event
                    },
                    focus: _vm.clearProviderAutoComplete
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "item",
                      fn: function(ref) {
                        var item = ref.item
                        var tile = ref.tile
                        return [
                          _vm._v(
                            "\n          " +
                              _vm._s(item.firstName) +
                              " " +
                              _vm._s(item.lastName) +
                              "\n          "
                          ),
                          _vm.isMobile && item.credentialType
                            ? _c("span", [
                                _vm._v("/" + _vm._s(item.credentialType))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isMobile && item.credentialName
                            ? _c("span", [
                                _vm._v("/" + _vm._s(item.credentialName))
                              ])
                            : _vm._e()
                        ]
                      }
                    },
                    {
                      key: "selection",
                      fn: function(ref) {
                        var item = ref.item
                        var selected = ref.selected
                        return [
                          _vm._v(
                            "\n          " +
                              _vm._s(item.firstName) +
                              " " +
                              _vm._s(item.lastName) +
                              "\n          "
                          ),
                          _vm.isMobile && item.credentialType
                            ? _c("span", [
                                _vm._v("/" + _vm._s(item.credentialType))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isMobile && item.credentialName
                            ? _c("span", [
                                _vm._v("/" + _vm._s(item.credentialName))
                              ])
                            : _vm._e()
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.selectedProvider,
                    callback: function($$v) {
                      _vm.selectedProvider = $$v
                    },
                    expression: "selectedProvider"
                  }
                },
                [
                  _vm._v(" "),
                  _vm._v(" "),
                  _c(
                    "template",
                    { slot: "no-data" },
                    [
                      _c(
                        "v-list",
                        [
                          !_vm.providerSearchInput
                            ? _c("v-list-tile", [
                                _vm._v(
                                  "\n              Please type a Provider.\n            "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.providerSearchInput && !_vm.providerSearchLoading
                            ? _c("v-list-tile", [
                                _vm._v(
                                  "\n              No Results\n            "
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { class: { "py-0": _vm.isMobile }, attrs: { xs12: "", sm4: "" } },
            [
              _c(
                "v-autocomplete",
                {
                  attrs: {
                    dense: "",
                    label: "Student's School",
                    placeholder: "Enter Student's School",
                    items: _vm.schoolArray,
                    clearable: true,
                    "return-object": true,
                    "search-input": _vm.schoolSearchInput,
                    "item-text": "schoolName",
                    "error-messages": _vm.schoolSearchError,
                    loading: _vm.schoolSearchLoading,
                    "no-filter": true
                  },
                  on: {
                    "update:searchInput": function($event) {
                      _vm.schoolSearchInput = $event
                    },
                    "update:search-input": function($event) {
                      _vm.schoolSearchInput = $event
                    },
                    focus: _vm.clearSchoolAutoComplete
                  },
                  model: {
                    value: _vm.selectedSchool,
                    callback: function($$v) {
                      _vm.selectedSchool = $$v
                    },
                    expression: "selectedSchool"
                  }
                },
                [
                  _c(
                    "template",
                    { slot: "no-data" },
                    [
                      _c(
                        "v-list",
                        [
                          !_vm.schoolSearchInput
                            ? _c("v-list-tile", [
                                _vm._v(
                                  "\n              Please type a School.\n            "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.schoolSearchInput && !_vm.schoolSearchLoading
                            ? _c("v-list-tile", [
                                _vm._v(
                                  "\n              No Results\n            "
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { class: { "pt-0": _vm.isMobile }, attrs: { xs12: "", sm4: "" } },
            [
              _c(
                "v-btn",
                {
                  staticClass: "retrieve-students-button",
                  attrs: {
                    color: "primary",
                    disabled: !_vm.selectedSchool || !_vm.selectedProvider,
                    block: ""
                  },
                  on: { click: _vm.getStudentList }
                },
                [_vm._v("\n        Retrieve Students\n      ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-toolbar",
        {
          staticClass: "student-service-toolbar",
          class: _vm.$mq,
          attrs: { color: "primary", dark: "" }
        },
        [
          _c("v-toolbar-title", { staticClass: "white--text" }, [
            _vm.retrieveStudentsClicked
              ? _c(
                  "span",
                  {
                    class: {
                      subheading: !_vm.isMobile,
                      "body-2 small": _vm.isMobile
                    }
                  },
                  [
                    _vm.providerInformation
                      ? _c("span", { staticClass: "font-weight-bold" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.providerInformation) +
                              "\n            "
                          ),
                          _vm.isMobile && _vm.providerCredentialType
                            ? _c("span", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.providerCredentialType) +
                                    "\n            "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isMobile && _vm.providerCredentialName
                            ? _c("span", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.providerCredentialName) +
                                    "\n            "
                                )
                              ])
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _vm.schoolName
                      ? _c("span", [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.schoolName) +
                              "\n          "
                          )
                        ])
                      : _vm._e()
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mr-3" },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  !_vm.isMobile
                    ? _c(
                        "v-flex",
                        {
                          staticClass: "white--text",
                          class: { "font-weight-bold": !_vm.allSupports },
                          staticStyle: {
                            "padding-top": "20px",
                            "font-size": "16px"
                          }
                        },
                        [_vm._v("\n          Unassigned\n        ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-tooltip",
                    { attrs: { disabled: !_vm.showTooltip, top: "" } },
                    [
                      _c(
                        "v-switch",
                        {
                          staticStyle: { "padding-top": "20px" },
                          attrs: { slot: "activator", color: "accent" },
                          slot: "activator",
                          model: {
                            value: _vm.allSupports,
                            callback: function($$v) {
                              _vm.allSupports = $$v
                            },
                            expression: "allSupports"
                          }
                        },
                        [
                          _c("template", { slot: "label" }, [
                            _c(
                              "span",
                              {
                                class: {
                                  "accent--text": _vm.allSupports,
                                  "font-weight-bold": _vm.allSupports,
                                  small: _vm.isMobile
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  All Services\n                "
                                )
                              ]
                            )
                          ])
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          "Toggle to view All Services or only services where provider is not assigned"
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.studentsList && _vm.studentsList.length
        ? _c(
            "v-flex",
            _vm._l(_vm.studentsList, function(student, i) {
              return _c(
                "div",
                { key: i, staticClass: "py-3 student-container" },
                [
                  _c(
                    "v-layout",
                    {
                      staticClass: "studentInfo",
                      attrs: { "ma-0": "", "pa-0": "" }
                    },
                    [
                      _c(
                        "v-flex",
                        {
                          class: {
                            "pa-0 pl-3": _vm.isMobile,
                            "py-1 px-4": !_vm.isMobile
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              class: {
                                "body-2 pt-1 display-block": _vm.isMobile,
                                "subheading font-weight-bold": !_vm.isMobile
                              }
                            },
                            [
                              _c(
                                "span",
                                { class: { "font-weight-bold": _vm.isMobile } },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(student.firstName) +
                                      " " +
                                      _vm._s(student.lastName) +
                                      "\n            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { disabled: !_vm.showTooltip, top: "" }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "activator" },
                                      slot: "activator"
                                    },
                                    [
                                      _vm._v(
                                        "(" + _vm._s(student.studentExtId) + ")"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      "\n                Student ID\n              "
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              class: {
                                caption: _vm.isMobile,
                                subheading: !_vm.isMobile
                              }
                            },
                            [
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { disabled: !_vm.showTooltip, top: "" }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      class: { "pl-3": !_vm.isMobile },
                                      attrs: { slot: "activator" },
                                      slot: "activator"
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(student.gender) +
                                          "\n                  "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Gender")])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  class: {
                                    "pl-2": _vm.isMobile,
                                    "pl-3": !_vm.isMobile
                                  }
                                },
                                [
                                  _c("strong", [
                                    _vm._v("Gr: " + _vm._s(student.grade))
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  class: {
                                    "pl-2": _vm.isMobile,
                                    "pl-3": !_vm.isMobile
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(student.schoolName) +
                                      "\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { disabled: !_vm.showTooltip, top: "" }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "activator" },
                                      slot: "activator"
                                    },
                                    [
                                      _vm._v(
                                        "(" + _vm._s(student.schoolCode) + ")"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Student's School Code")])
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  student.services.length
                    ? _c(
                        "div",
                        _vm._l(student.services, function(service, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "student-service-row" },
                            [
                              _c(
                                "v-layout",
                                {
                                  attrs: {
                                    row: "",
                                    rap: "",
                                    "mx-4": "",
                                    "my-1": ""
                                  }
                                },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        xs11: "",
                                        sm10: "",
                                        md9: "",
                                        "pa-0": ""
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "student-service-row-text",
                                          class: {
                                            "warning--text": !service.active,
                                            "caption mobile-padding":
                                              _vm.isMobile,
                                            "body-2 py-1": !_vm.isMobile
                                          }
                                        },
                                        [
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: {
                                                disabled: !_vm.showTooltip,
                                                top: ""
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  class: {
                                                    "pr-3": _vm.isMobile
                                                  },
                                                  attrs: { slot: "activator" },
                                                  slot: "activator"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        service.planTypeName
                                                      ) +
                                                      ": " +
                                                      _vm._s(
                                                        service.serviceType
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v("Plan Type/Service")
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          !_vm.isMobile
                                            ? _c(
                                                "span",
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "dot-icon",
                                                      class: {
                                                        "warning--text": !service.active
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    mdi-circle-small\n                  "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: {
                                                disabled: !_vm.showTooltip,
                                                top: ""
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  attrs: { slot: "activator" },
                                                  slot: "activator"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm._f("formatDate")(
                                                          service.startDate
                                                        )
                                                      ) +
                                                      " -\n                    " +
                                                      _vm._s(
                                                        _vm._f("formatDate")(
                                                          service.endDate
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  "Projected Start/End Dates"
                                                )
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          !_vm.isMobile
                                            ? _c(
                                                "span",
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "dot-icon",
                                                      class: {
                                                        "warning--text": !service.active
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    mdi-circle-small\n                  "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.isMobile
                                            ? _c("span", [_c("br")])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: {
                                                disabled: !_vm.showTooltip,
                                                top: ""
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  class: {
                                                    "pr-3": _vm.isMobile
                                                  },
                                                  attrs: { slot: "activator" },
                                                  slot: "activator"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        service.frequency
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v("Service Frequency")
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          service.esy
                                            ? _c(
                                                "span",
                                                [
                                                  !_vm.isMobile
                                                    ? _c(
                                                        "span",
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "dot-icon",
                                                              class: {
                                                                "warning--text": !service.active
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                      mdi-circle-small\n                    "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: {
                                                        disabled: !_vm.showTooltip,
                                                        top: ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          attrs: {
                                                            slot: "activator"
                                                          },
                                                          slot: "activator"
                                                        },
                                                        [_vm._v("(ESY)")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("has ESY")
                                                      ])
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        xs1: "",
                                        sm2: "",
                                        md3: "",
                                        "pa-0": "",
                                        "text-xs-right": ""
                                      }
                                    },
                                    [
                                      !!service.addType
                                        ? _c(
                                            "div",
                                            {
                                              on: {
                                                click: function($event) {
                                                  return _vm.addProvider(
                                                    service.serviceId
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm.isMobile
                                                ? _c("div", [
                                                    service.addType === "TEAM"
                                                      ? _c(
                                                          "span",
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                staticClass:
                                                                  "secondary--text"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                      mdi-lock-plus\n                    "
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      : _c(
                                                          "span",
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                staticClass:
                                                                  "secondary--text"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                      mdi-account-plus\n                    "
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                  ])
                                                : _vm.isTablet
                                                ? _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          staticClass:
                                                            "actionButton-tablet",
                                                          attrs: {
                                                            color: "secondary",
                                                            small: "",
                                                            round: ""
                                                          }
                                                        },
                                                        [
                                                          service.addType ===
                                                          "TEAM"
                                                            ? _c(
                                                                "span",
                                                                [
                                                                  _c(
                                                                    "v-tooltip",
                                                                    {
                                                                      attrs: {
                                                                        disabled: !_vm.showTooltip,
                                                                        top: ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          attrs: {
                                                                            slot:
                                                                              "activator"
                                                                          },
                                                                          slot:
                                                                            "activator"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "small",
                                                                            [
                                                                              _vm._v(
                                                                                "Add Team"
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "Add provider to student team"
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          service.addType ===
                                                          "PROVIDER"
                                                            ? _c(
                                                                "span",
                                                                [
                                                                  _c(
                                                                    "v-tooltip",
                                                                    {
                                                                      attrs: {
                                                                        disabled: !_vm.showTooltip,
                                                                        top: ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          attrs: {
                                                                            slot:
                                                                              "activator"
                                                                          },
                                                                          slot:
                                                                            "activator"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "small",
                                                                            [
                                                                              _vm._v(
                                                                                "Add Provider"
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "Add provider to student team and service"
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          staticClass:
                                                            "actionButton",
                                                          attrs: {
                                                            color: "secondary",
                                                            small: "",
                                                            round: ""
                                                          }
                                                        },
                                                        [
                                                          service.addType ===
                                                          "TEAM"
                                                            ? _c(
                                                                "span",
                                                                [
                                                                  _c(
                                                                    "v-tooltip",
                                                                    {
                                                                      attrs: {
                                                                        disabled: !_vm.showTooltip,
                                                                        top: ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          attrs: {
                                                                            slot:
                                                                              "activator"
                                                                          },
                                                                          slot:
                                                                            "activator"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-icon",
                                                                            {
                                                                              staticClass:
                                                                                "icon-padding",
                                                                              attrs: {
                                                                                small:
                                                                                  ""
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                            mdi-lock-plus\n                          "
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "small",
                                                                            [
                                                                              _vm._v(
                                                                                "Add Team"
                                                                              )
                                                                            ]
                                                                          )
                                                                        ],
                                                                        1
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "Add provider to student team"
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          service.addType ===
                                                          "PROVIDER"
                                                            ? _c(
                                                                "span",
                                                                [
                                                                  _c(
                                                                    "v-tooltip",
                                                                    {
                                                                      attrs: {
                                                                        disabled: !_vm.showTooltip,
                                                                        top: ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          attrs: {
                                                                            slot:
                                                                              "activator"
                                                                          },
                                                                          slot:
                                                                            "activator"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-icon",
                                                                            {
                                                                              staticClass:
                                                                                "icon-padding",
                                                                              attrs: {
                                                                                small:
                                                                                  ""
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "mdi-account-plus"
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "small",
                                                                            [
                                                                              _vm._v(
                                                                                "Add Provider"
                                                                              )
                                                                            ]
                                                                          )
                                                                        ],
                                                                        1
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "Add provider to student team and service"
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !!service.removeType
                                        ? _c(
                                            "div",
                                            {
                                              on: {
                                                click: function($event) {
                                                  return _vm.removeProvider(
                                                    service.providerId
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm.isMobile
                                                ? _c("div", [
                                                    service.removeType ===
                                                    "TEAM"
                                                      ? _c(
                                                          "span",
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                staticClass:
                                                                  "error--text"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                      mdi-lock-open\n                    "
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    service.removeType ===
                                                    "PROVIDER"
                                                      ? _c(
                                                          "span",
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                staticClass:
                                                                  "error--text"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                      mdi-account-remove\n                    "
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e()
                                                  ])
                                                : _vm.isTablet
                                                ? _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          staticClass:
                                                            "actionButton-tablet remove",
                                                          attrs: {
                                                            small: "",
                                                            round: ""
                                                          }
                                                        },
                                                        [
                                                          service.removeType ===
                                                          "TEAM"
                                                            ? _c(
                                                                "span",
                                                                [
                                                                  _c(
                                                                    "v-tooltip",
                                                                    {
                                                                      attrs: {
                                                                        disabled: !_vm.showTooltip,
                                                                        top: ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          attrs: {
                                                                            slot:
                                                                              "activator"
                                                                          },
                                                                          slot:
                                                                            "activator"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "small",
                                                                            [
                                                                              _vm._v(
                                                                                "Remove from Team"
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "Remove provider from student team"
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          service.removeType ===
                                                          "PROVIDER"
                                                            ? _c(
                                                                "span",
                                                                [
                                                                  _c(
                                                                    "v-tooltip",
                                                                    {
                                                                      attrs: {
                                                                        disabled: !_vm.showTooltip,
                                                                        top: ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          attrs: {
                                                                            slot:
                                                                              "activator"
                                                                          },
                                                                          slot:
                                                                            "activator"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "small",
                                                                            [
                                                                              _vm._v(
                                                                                "\n                            Remove Provider\n                          "
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "Remove provider from student team and service"
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          staticClass:
                                                            "actionButton remove",
                                                          attrs: {
                                                            small: "",
                                                            round: ""
                                                          }
                                                        },
                                                        [
                                                          service.removeType ===
                                                          "TEAM"
                                                            ? _c(
                                                                "span",
                                                                [
                                                                  _c(
                                                                    "v-tooltip",
                                                                    {
                                                                      attrs: {
                                                                        disabled: !_vm.showTooltip,
                                                                        top: ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          attrs: {
                                                                            slot:
                                                                              "activator"
                                                                          },
                                                                          slot:
                                                                            "activator"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-icon",
                                                                            {
                                                                              staticStyle: {
                                                                                "padding-right":
                                                                                  "10px"
                                                                              },
                                                                              attrs: {
                                                                                small:
                                                                                  ""
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                            mdi-lock-open\n                          "
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "small",
                                                                            [
                                                                              _vm._v(
                                                                                "Remove From Team"
                                                                              )
                                                                            ]
                                                                          )
                                                                        ],
                                                                        1
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "Remove provider from student team"
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          service.removeType ===
                                                          "PROVIDER"
                                                            ? _c(
                                                                "span",
                                                                [
                                                                  _c(
                                                                    "v-tooltip",
                                                                    {
                                                                      attrs: {
                                                                        disabled: !_vm.showTooltip,
                                                                        top: ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          attrs: {
                                                                            slot:
                                                                              "activator"
                                                                          },
                                                                          slot:
                                                                            "activator"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-icon",
                                                                            {
                                                                              staticStyle: {
                                                                                "padding-right":
                                                                                  "10px"
                                                                              },
                                                                              attrs: {
                                                                                small:
                                                                                  ""
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                            mdi-account-remove\n                          "
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "small",
                                                                            [
                                                                              _vm._v(
                                                                                "Remove Provider"
                                                                              )
                                                                            ]
                                                                          )
                                                                        ],
                                                                        1
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "Remove provider from student team and service"
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  ),
                                  _vm._v(" "),
                                  index < student.services.length - 1
                                    ? _c("div", {
                                        class: { "mt-50": _vm.isMobile }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-alert",
                                {
                                  attrs: {
                                    value: !!service.errorMessage,
                                    type: "error"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(service.errorMessage) +
                                      "\n          "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _vm._e()
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.retrieveStudentsClicked
        ? _c(
            "v-flex",
            [
              _c("v-flex", { staticClass: "font-italic py-3 px-1" }, [
                _vm._v(
                  '\n      No Students.  Select a Provider and Student\'s School above,\n      then click on "Retrieve Students"\n    '
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-alert",
        {
          staticClass: "mt-3 mb-5",
          attrs: { value: _vm.errorMsg, type: "error" }
        },
        [_vm._v("\n    " + _vm._s(_vm.errorMsg) + "\n  ")]
      ),
      _vm._v(" "),
      _vm.showLoading ? _c("full-screen-loading-spinner") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54f802c7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54f802c7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/scheduler/add-by-provider.vue
// module id = null
// module chunks = 